import React, { memo, useState } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Row, Col, Input, Result, Icon } from 'antd';

import { makeSelectUser } from '@/global.selectors';
import './style.less';

function Login() {
  const [token, setToken] = useState('');
  const handleSaveToken = () => {
    localStorage.setItem('token', token);
    window.location.reload();
  }
  return (
    <>
      <Helmet>
        <title>Chấm Công</title>
        <meta name="description" content="Vui lòng liên hệ Admin để lấy mã đăng nhập" />
      </Helmet>
      <Result
        icon={<Icon type="smile" theme="twoTone" />}
        title="Vui lòng liên hệ Admin để lấy mã đăng nhập!!!"
      />
      <Row>
        <Col sm={6}></Col>
        <Col sm={12}>
          <Input 
            onChange={e => setToken(e.target.value)} onPressEnter={handleSaveToken} 
            value={token} 
            style={{width: '100%'}} placeholder='Mã đăng nhập' />
        </Col>
      </Row>
    </>
  );
}

Login.propTypes = {
};

Login.defaultProps = {
};

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});

const mapDispatchToProps = dispatch => ({
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(Login);
